/*
 * @Author: wzc
 * @Date: 2024-06-29 10:42:36
 * @LastEditors: wzc
 * 超赛平台 base mixins 横琴马拉松
 * @LastEditTime: 2024-06-29 19:11:02
 */

export default {
  data() {
    return {
      containerFullClassName: 'containerFull_marathon_HengqinMara',
      defaultPath: ['marathon', 'HengqinMara', 'signup'],
      axiosBaseUrl: '/marathon',
      sportCompetitionType: 'mararhon_HengqinMara', //暂时不加具体中网|汤尤杯这种赛事区别，如果需要后面补字段即可【tennis_chinaOpen,badminton_thomasAndUber】
      themeSeasonArr: [
        {
          sidArr: ['10001'],
          themeIndex: 0,
        },
      ],
    }
  },
}
